import { render, staticRenderFns } from "./DivisionIndex.vue?vue&type=template&id=218513a8"
import script from "./DivisionIndex.vue?vue&type=script&lang=js"
export * from "./DivisionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports